module.exports = __webpack_public_path__ + "img/cupo_femenino.ab69b621.jpg";